function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      document.getElementById('header-drawer').classList.remove('menu-opening-mm');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      document.getElementById('header-drawer').classList.add('menu-opening-mm');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.scrollContainer = this.querySelector(".product-thumbnails-section");
    this.sliderSmall = this.querySelector('.product-thumbnails-section ul.thumbnails-slider_mobile');
    this.sliderItemsSmall = this.querySelectorAll('.product-thumbnails-section  ul.thumbnails-slider_mobile li');
    this.oldPage;
    this.stableElements= [];

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', this.update.bind(this));
    for ( this.sliderItemSmall of this.sliderItemsSmall) {
     this.sliderItemSmall.addEventListener('click',  this.smallIndex.bind(this));
    }

    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.prevButton.addEventListener('click', this.sliderMove.bind(this));
    this.nextButton.addEventListener('click', this.sliderMove.bind(this)); 
  }

     
  smallIndex(event){
    event.preventDefault();
    console.log(document.getElementById("thumbnail-bottom-slider").childElementCount);
    let position = $(event.currentTarget).index();
    this.update(position)
    this.slider.scrollTo({
      left: position * this.sliderItems[0].clientWidth
    });
    };

  initPages() {
    if (!this.sliderItems.length === 0) return;
    if (!this.sliderItemsSmall.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update(position) {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages/2) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    var position ;

  if(position){
    this.pageCount.textContent = position;
    this.sliderMove(position);
  }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages/2;
    this.sliderMove(this.currentPage,this.oldPage);
    this.oldPage = this.currentPage;
  }

  sliderMove(page,oldPage) {
  const currentPage = page-1;
   const elementNot=".product-thumbnails-section  ul.thumbnails-slider_mobile li";
   $( elementNot ).removeClass( "slider__active" );
  const element=".product-thumbnails-section  ul.thumbnails-slider_mobile li:eq("+ currentPage +")";


  this.sliderSmall.addEventListener("wheel", (evt) => {
    evt.preventDefault();
    this.sliderSmall.scrollLeft += (evt.deltaY-20);
  });

  $( element ).addClass( "slider__active" );

  let newCurrentItem = currentPage+1;
  let oneStep = Math.floor(this.scrollContainer.clientWidth / (this.sliderItemsSmall[0].clientWidth + 3));
  let singleElemetnScrollWidth = this.sliderItemsSmall[0].clientWidth + 3;
  let scrollL = singleElemetnScrollWidth * 2;
  let scrollR  = singleElemetnScrollWidth * (oneStep);

    if (page >= oldPage){

      if(this.stableElements.includes(newCurrentItem)){
      } else{
        this.sliderSmall.scrollTo({
          left: (newCurrentItem * singleElemetnScrollWidth) - scrollR
        });
        for (let i=0; i < oneStep-2; i++ ){
          this.stableElements[i] = page - i;
        }
      }
    }else if(page < oldPage){
      if(this.stableElements.includes(newCurrentItem)){
      }else{
        this.sliderSmall.scrollTo({
          left: (newCurrentItem * singleElemetnScrollWidth) - scrollL
        });
        for (let i=0; i < oneStep-2; i++ ){
          this.stableElements[i] = page+i;
        }
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }  

}


customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {

      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    var allThumbSmallElement=document.querySelectorAll(".product-thumbnails-section  ul.thumbnails-slider_mobile li");
    for(i=0; i<allThumbSmallElement.length; i++)
     { 
      allThumbSmallElement[i].classList.remove('slider__active');
     }
   
    var allThumbSmallElementFirst = document.querySelectorAll(".product-thumbnails-section  ul.thumbnails-slider_mobile li");
    allThumbSmallElementFirst[0].classList.add('slider__active');
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    console.log("this.options",this.options);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    console.log("this.currentVariant",this.currentVariant);
  }

  updateMedia() {
    console.log("update !!!!!!!!!!!!!");
    // if (!this.currentVariant || !this.currentVariant?.featured_media) return;
     console.log("update XXXXXXXXXXXXXXX");
     console.log(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

     const newMediaSmall = document.querySelector(
      `[data-media-id="${this.dataset.section}bottom-${this.currentVariant.featured_media.id}"]`
    );
    console.log(newMediaSmall);
    console.log(newMedia);
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    var mainQueue = document.getElementById('thumbnail-main-slider'); 
    // mainQueue.removeChild(mainQueue.firstChild);
    // mainQueue.insertAdjacentHTML("afterbegin", newMedia.outerHTML);
    mainQueue.insertBefore(mainQueue.firstChild,mainQueue.lastChild);
    mainQueue.insertBefore(newMedia,mainQueue.firstChild);
    // mainQueue.insertBefore(mainQueue.children[1],mainQueue.lastChild);
    window.setTimeout(() => { parent.scroll(0, 0) });
    if (newMediaSmall != null){
      const parentSmall = newMediaSmall.parentElement; 
      var bottomQueue = document.getElementById('thumbnail-bottom-slider'); 
      // bottomQueue.removeChild(bottomQueue.firstChild);
      // bottomQueue.insertAdjacentHTML("afterbegin", newMediaSmall.outerHTML);
      bottomQueue.insertBefore(bottomQueue.firstChild,bottomQueue.lastChild);
      bottomQueue.insertBefore(newMediaSmall,bottomQueue.firstChild);
      // bottomQueue.insertBefore(bottomQueue.children[1],bottomQueue.lastChild);
      window.setTimeout(() => { parentSmall.scroll(0, 0) });
    
    };
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    
    if(document.querySelector('.price-item.price-item--regular span') != null){
      var priceToUpdate = document.querySelector('.price-item.price-item--regular span');
      priceToUpdate.innerHTML = '$' + (Math.round(this.currentVariant.price) / 100).toFixed(2);
    } 
    // else {
    //   var priceToUpdate = document.querySelector('.price-item.price-item--regular');
    //   priceToUpdate.innerHTML = '<span class="bold_option_price_display">$' + (Math.round(this.currentVariant.price) / 100).toFixed(2) +'</span>';
    // }
    
    document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');        
       this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');        
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    console.log("test 222");
     const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('.product-form__submit');
    const notifyButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('.klaviyo-bis-trigger');
    const bottomButton = document.getElementById("cart-bar-add");
    if (!addButton) return;
    console.log(this.currentVariant );
    if (disable) {
      console.log('if disable');
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
      if( this.currentVariant.available == false && notifyButton != undefined){
        notifyButton.classList.remove('hidden');      
        notifyButton.classList.add('vis');
        console.log('here 3');
      
      }
    
    
      bottomButton.setAttribute('disabled', true);
      if (text) bottomButton.textContent = text;
    } else {
      console.log('if disable false');
    
      if(this.currentVariant.available == true && notifyButton != undefined){
        notifyButton.classList.add('hidden');
        notifyButton.classList.remove('vis');
        console.log('here 2');
      }
      if( this.currentVariant.available == false && notifyButton != undefined){
        notifyButton.classList.remove('hidden');      
        notifyButton.classList.add('vis');
        console.log('here');
      }
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
      bottomButton.removeAttribute('disabled');
      bottomButton.textContent = window.variantStrings.addToCart;
    
    }
  
    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('.product-form__submit.bold_clone');
    const bottomButton = document.getElementById("cart-bar-add");
    
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    bottomButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    console.log(JSON.parse(this.querySelector('[type="application/json"]').textContent));
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

  
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
// var mainEl = document.getElementById("select-geolocation__popup"); 
// var background_popup = document.getElementById("background-geolocation__popup"); 
// var closeButton = document.getElementById("geolocation-popup__close-button"); 
// var buttonGeolocation = document.getElementById("geolocation__popup"); 
// var buttonGeolocationFooter = document.getElementById("geolocation__popup-footer"); 
// var buttonGeolocationMobileMenu = document.getElementById("geolocation__popup-mobile-menu"); 
// var topMenuButton= document.getElementById("location-top__banner-content"); 
// var topMenuButtonFooter= document.getElementById("location-top__banner-content-footer");
// var topMenuButtonMobileMenu= document.getElementById("location-top__banner-mobile-menu");
// var australiaButton = document.getElementById("australia-geolocation"); 
// var canadaButton = document.getElementById("canada-geolocation"); 
// var singaporeButton = document.getElementById("singapore-geolocation"); 

// var canadaImg = "<img src='https://cdn.shopify.com/s/files/1/0570/2218/5644/files/canada-flag.png?v=1640178730' alt='language icon2' width='21px' height='21px' class='top-icon'><span id='location-top__banner-name' class='menu-item-title'> Canada </span> ";
// var australiaImg = "<img src='https://cdn.shopify.com/s/files/1/0570/2218/5644/files/australia-flag.png?v=1640126990'   alt='language icon2' width='21px' height='21px' class='top-icon'><span id='location-top__banner-name' class='menu-item-title'> Canada </span> ";
// var singaporeImg = "<img src='https://cdn.shopify.com/s/files/1/0605/8075/7653/files/singapore-flag.png?v=1642517587'   alt='language icon2' width='21px' height='21px' class='top-icon'><span id='location-top__banner-name' class='menu-item-title'> Canada </span> ";

// var currentURL = window.location.href;
// if(currentURL.indexOf('com.au') > 0){
//   changeLocation('australia');
// } else if(currentURL.indexOf('co.nz') > 0){
//   changeLocation('canada');
// }
// if(getCookie('loc_popup') != 'closed'){
//   mainEl.classList.remove('hide');
// }

// topMenuButton.innerHTML= canadaImg;
// topMenuButtonFooter.innerHTML= canadaImg;
// topMenuButtonMobileMenu.innerHTML= canadaImg;

// background_popup.addEventListener('click', geolocationPopup);
// closeButton.addEventListener('click', geolocationPopup);
// buttonGeolocation.addEventListener('click', geolocationPopup);
// buttonGeolocationFooter.addEventListener('click', geolocationPopup);
// buttonGeolocationMobileMenu.addEventListener('click', geolocationPopupMobileMenu);
// australiaButton.addEventListener('click',function(){changeLocation('australia');}, false);
// canadaButton.addEventListener('click',function(){changeLocation('canada');}, false);
// singaporeButton.addEventListener('click',function(){changeLocation('singapore');}, false);


// function geolocationPopupMobileMenu() {
//   document.querySelector("summary").click();
//   geolocationPopup();
// }

// function geolocationPopup() {
//   var mainEl = document.getElementById("select-geolocation__popup"); 
//   if (mainEl.classList.contains('hide')){
//     mainEl.classList.remove('hide');

//   }else{
//     mainEl.classList.add('hide');
//     setCookie('loc_popup','closed',1);
//   }
// }

// function changeLocation (location) {
//   if( location == "australia"){
//     topMenuButton.innerHTML = australiaImg;
//     topMenuButtonFooter.innerHTML = australiaImg;
//     topMenuButtonMobileMenu.innerHTML = australiaImg;
//   }else if (location == "canada"){
//     topMenuButton.innerHTML=canadaImg;
//     topMenuButtonFooter.innerHTML=canadaImg;
//     topMenuButtonMobileMenu.innerHTML=canadaImg;
//   }else if (location == "singapore"){
//     topMenuButton.innerHTML=singaporeImg;
//     topMenuButtonFooter.innerHTML=singaporeImg;
//     topMenuButtonMobileMenu.innerHTML=singaporeImg;
//   }
// }


// var ip ;
// var access_key = '18b7da2844df59593e5920221afcd5b8';


// if(!getCookie('userCountry')){
//   fetch("https://api.ipify.org/?format=json")
//     .then(response => response.json())
//     .then(data => getIp(data.ip) );
//   function getIp(ip){
//     var url = 'http://api.ipstack.com/' + ip + '?access_key=' + access_key;
//     fetch(url)
//       .then(res => res.json())
//       .then( function (obj){
//           setCookie('userCountry',obj.country_name,30);
//     });
//   }
// }

// var urlCurrentCheck ;
// if (currentURL.indexOf('com.au') > 0  ){
//   urlCurrentCheck = "Australia"
// }else if (currentURL.indexOf('co.nz')> 0  ){
//   urlCurrentCheck = "Canada"
// }

            
// setTimeout(function(){
//  if ( urlCurrentCheck == getCookie('userCountry') ){
//    setCookie('anotherCountry','confirmed',30);
//  }else if (!getCookie('anotherCountry')){
//    geolocationPopup() ;
//    setCookie('anotherCountry','confirmed',30);
//  }
// }, 5000);

function closeTopBarDiscount(){
  
  if(!getCookie('topBarDiscount')){
    $('.very-top-bar').addClass('active');
  } else {
    
  }
  $('.very-top-bar').on('click','.close-button', function(){
    setCookie('topBarDiscount','closed',1);
    $('.very-top-bar').removeClass('active');
  });
}
closeTopBarDiscount();

function closeAfterHeaderBar(){
  
  if(!getCookie('afterHeaderBar')){
    $('.nav-usps').addClass('active');
  } else {
    
  }
  $('.nav-usps').on('click','.close-button', function(){
    setCookie('afterHeaderBar','closed',1);
    $('.nav-usps').removeClass('active');
  });
}
closeAfterHeaderBar();
// var quantityInputs = document.querySelectorAll('.main-cart__slider .quantity__input');

// quantityInputs.forEach(element => {
//   console.log(element);
//   element.addEventListener('keypress', logKey);
// });
document.addEventListener('keypress', logKey);
function logKey(e) {
  console.log(e.target.classList.contains('quantity__input'));
  console.log(e.target.closest('.btns-slider'));  
  if(e.target.closest('.btns-slider') && e.target.classList.contains('quantity__input') && (e.code == 'Enter' || e.code == 'NumpadEnter')){
    e.preventDefault();
  }
}


// var topLiveChat = document.getElementById("top-menu-chat"); 
// var footerLiveChat = document.getElementById("footer-open-chat");  
// let openHide = false;


// topLiveChat.addEventListener('click', chatWithUsLive);
// footerLiveChat.addEventListener('click', chatWithUsLive);
// function chatWithUsLive() {
//   if ( openHide == false){
//     LiveChatWidget.call('maximize');
//     openHide = true;
//   } else if( openHide == true ){
//     LiveChatWidget.call('minimize');
//     openHide = false;
//   }
// };

// var buttonReviews = document.getElementById("stamped-product__main-badge");  
// var tabReviews = document.getElementById("tab-review");     
// buttonReviews.addEventListener("click", function(event){
// tabReviews.click();
// event.preventDefault();
// });
